
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 341.3"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#338AF3","d":"M0 0h512v341.3H0z"}}),_c('path',{attrs:{"fill":"#FFDA44","d":"M512 66.9V0H411.7L0 274.4v66.9h100.3z"}}),_c('path',{attrs:{"fill":"#D80027","d":"M512 0v40.1L60.2 341.3H0v-40.1L451.8 0z"}}),_c('path',{attrs:{"fill":"#FFDA44","d":"M93.6 31.2l16.3 50.4H163l-42.9 31.2 16.4 50.5-42.9-31.2-43 31.2L67 112.8 24.1 81.6h53.1z"}})])
          )
        }
      }
    